/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Open_PropertiesInputs */

const cs_ebr_open_properties = /** @type {(inputs: Ebr_Open_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít nemovitosti`)
};

const en_ebr_open_properties = /** @type {(inputs: Ebr_Open_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open properties`)
};

/**
* | output |
* | --- |
* | "Open properties" |
*
* @param {Ebr_Open_PropertiesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_open_properties = /** @type {((inputs?: Ebr_Open_PropertiesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Open_PropertiesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_open_properties(inputs)
	return cs_ebr_open_properties(inputs)
});